import posthog from "posthog-js"

// Basic product analytics. Enabled only when the layout renders the
// posthog-key meta tag (i.e. POSTHOG_API_KEY is set for the environment).
const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content

const key = meta("posthog-key")

if (key) {
  posthog.init(key, {
    api_host: meta("posthog-host") || "https://us.i.posthog.com",
    // history_change pageview capture, so Turbo Drive navigations count.
    defaults: "2026-05-30",
    // no person profiles for anonymous visitors (cheaper; identify() upgrades them)
    person_profiles: "identified_only"
  })

  const userId = meta("posthog-user-id")
  if (userId && posthog.get_distinct_id() !== userId) {
    posthog.identify(userId)
  }
}
